import CustomerService from '@/pages/CustomerService';

export default function MobileCustomerService() {
  return <CustomerService />;
}

